import { createFileRoute, Link } from "@tanstack/react-router";
import { type ColumnDef } from "@tanstack/react-table";
import { listUsers } from "@/lib/api/users.functions";
import { DataTable } from "@/components/admin/DataTable";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { AdminPageShell } from "@/components/admin/AdminPageShell";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/admin/users/")({
  loader: () => listUsers(),
  component: AdminUsersPage,
});

type Row = Awaited<ReturnType<typeof listUsers>>[number];

const columns: ColumnDef<Row>[] = [
  { accessorKey: "name", header: "Name" },
  { accessorKey: "email", header: "Email" },
  {
    accessorKey: "roleName",
    header: "Role",
    meta: { filterVariant: "select", groupable: true },
  },
  {
    accessorKey: "isActive",
    header: "Active",
    meta: { filterVariant: "select", groupable: true },
    cell: ({ row }) => (row.original.isActive ? "Yes" : "No"),
  },
];

function AdminUsersPage() {
  const users = Route.useLoaderData();
  return (
    <AdminPageShell>
      <AdminPageHeader
        title="Users"
        action={
          <Button asChild>
            <Link to="/admin/users/new">
              <Plus className="mr-2 h-4 w-4" /> New user
            </Link>
          </Button>
        }
      />
      <DataTable tableId="users" columns={columns} data={users} />
    </AdminPageShell>
  );
}
